export class ActionsModel {
    show: boolean;
}
